declare const angular: ng.IAngularStatic;
declare const app;
declare const window;
declare const $;
declare const google;

export class productIconToolbarController {
    BaseUrlPage: any;
    product;
    constructor(private $compare, private $favorit, private $availableAlert, private $state, private $notify, private $mPath, private $user, private $mdDialog, private MyConstant) {
        "ngInject"
        $mPath.get().then(
            Response => {
                this.BaseUrlPage = Response;
            }
        )
    }

    addtocompare() {
        this.$compare.add(this.product.ProductTypeID, this.product)
    }

    addToFavorit() {
        this.$user.getInfo().then(
            user => {
                if (user.data) {
                    let url = `/Orders-Tracking/UserId/${user.UserID}/Favorites`
                    let text;
                    this.$favorit.add({ productId: this.$state.params.pID },
                        response => {
                            if (response.data) {
                                text = 'محصول با موفقیت به لیست شما اضافه شد'
                                this.product.FavoriteStatus = true
                            }
                            else {
                                text = 'محصول در لیست شما موجود می باشد'
                            }
                            this.$notify.action({ text: text, action: 'مشاهده لیست', actionUrl: url })

                        }
                    )
                }
                else {
                    this.$user.showLogin()
                }
            },
            error => {
            }

        )

    }

    addToAvailableAlert() {
        this.$user.getInfo().then(
            user => {
                if (user.data) {
                    let url = `/Orders-Tracking/UserId/${user.UserID}/Notification`
                    let text;
                    this.$availableAlert.add({ productId: this.$state.params.pID },
                        response => {

                            if (response.data) {
                                text = 'محصول با موفقیت به لیست شما اضافه شد'
                                this.product.AlertStatus = true;
                            }
                            else {
                                text = 'محصول در لیست شما موجود می باشد'
                            }
                            this.$notify.action({ text: text, action: 'مشاهده لیست', actionUrl: url })

                        }
                    )
                }
                else {
                    this.$user.showLogin()
                }
            },
            error => {
            }
        )
    }

    lightBox(type) {
        let dynamic = []
        if (type == 'video') {
            if (this.product.UrlOfIntroduceVideo) {

                dynamic.push({
                    html: '#video2',
                    thumb: 'https://sachinchoolur.github.io/lightGallery/static/img/videos/y-video1-cover.jpg'
                })
            }
            else{
                dynamic.push({
                    'iframe': true,
                    src: this.product.UrlOfIntroduceIframe
                })
            }
        }
        else if (type == '360') {
            dynamic.push({
                'iframe': true,
                src: this.product.UrlOf360Show
            })
        }
        else if (type == '3d') {
            dynamic.push({
                'iframe': true,
                src: this.product.UrlOf3DShow
            })
        }
        // $(document).data('lightGallery').destroy()
        let lightGallery = $(document).lightGallery(
            {
                dynamic: true,
                hideBarsDelay: 99999999,
                mobileSrc: true,
                showThumbByDefault: false,
                download: false,
                // videojs:true,
                dynamicEl: dynamic
            }
        );
        $(document).on('onCloseAfter.lg', function () {
            if ($(document).data('lightGallery')) {

                $(document).data('lightGallery').destroy(true)
            }
        })
    }
    openMap(ev) {
        let item = {
            TypeID: 4,
            ID: this.product.ProductID
        }
        this.$mdDialog.show({
            controller: function ShowMapController($scope, $mdDialog, $VendorLoaction, NgMap, BaseUrl, item) {
                "ngInject"
                $scope.BaseUrlPage = BaseUrl;
                $scope.googleMapsUrl = "https://maps.googleapis.com/maps/api/js?key=AIzaSyDqLzkWTDlaVOOjFEnyv-xN_O3Zxw9QKPY"
                $scope.AjaxLoading = true

                $VendorLoaction.List(item.TypeID, item.ID).then(function (data) {
                    $scope.VendorList = data.data;
                    // 
                    // if($scope.VendorList.length === 1){
                    //     $scope.center = "'" + data[0].Latitude + "," + data[0].Longitude + "'";
                    // }
                    // if($scope.VendorList.length > 1){
                    //      $scope.center = "35.6807421,51.413044"
                    // }
                    // 
                    $scope.AjaxLoading = false
                    // 
                })
                NgMap.getMap().then(function (evtMap) {
                    $scope.map = evtMap;
                    var markers = evtMap.markers;
                    var bounds = new google.maps.LatLngBounds();
                    angular.forEach(markers, function (val, key) {
                        bounds.extend(val.position);
                    })
                    $scope.map.fitBounds(bounds);
                    if ($scope.VendorList.length === 1) {

                        $scope.map.setZoom(12);
                    }
                })
                $scope.showDetail = function (e, shop) {
                    $scope.vendorInfo = shop;
                    $scope.map.showInfoWindow('foo-iw', shop.VendorID.toString());
                };
                $scope.hideDetail = function () {
                    $scope.map.hideInfoWindow('foo-iw');
                };
                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

                $scope.answer = function (answer) {
                    $mdDialog.hide(answer);
                };
            },
            template: `<md-dialog class="vendor-on-map" aria-label="مشاهده فروشندگان روی نقشه" class="full-screen" flex="70">
            <form ng-cloak>
                <md-toolbar>
                <div class="md-toolbar-tools">
                    <h2>مشاهده فروشندگان روی نقشه</h2>
                    <span flex></span>
                    <md-button class="md-icon-button" ng-click="cancel()">
                    <md-icon class="fa fa-times" aria-label="Close dialog"></md-icon>
                    </md-button>
                </div>
                </md-toolbar>

                <md-dialog-content layout="row">
                <div style="min-height:300px">
                    <spn-loading ng-if="AjaxLoading"></spn-loading>
                </div>

                <div style="width: 100%;height: calc(100% - 56px);position: absolute;left:0;bottom:0" ng-if="!AjaxLoading" map-lazy-load="{{googleMapsUrl}}">
                    <ng-map style="width: 100%;height: 100%;" center="{{center}}" zoom="13">
                    <marker icon="{
                                url:'/DesktopModules/ECBMainStore/ECBMainView/img/ic_map_marker_black_36dp.png',
                                scaledSize:[30,30]
                                }" on-click="showDetail(vendor)" id="{{vendor.VendorID}}" ng-repeat="vendor in VendorList" title="{{vendor.Name}}"
                        position="[{{vendor.Latitude}}, {{vendor.Longitude}}]">
                    </marker>
                    <info-window id="foo-iw">
                        <div ng-non-bindable="" style="font-family:ecb;margin-right: 15px;">
                        نام فروشگاه: {{vendorInfo.Name}}<br/> لوگو: <img ng-src="{{vendorInfo.VendorImage}}" style="max-width:80px"
                            alt=""> <br/> نماد: <span ng-if="vendorInfo.HasENamad" style="color:green"><i class="fa fa-check"></i></span>
                        <span
                            ng-if="!vendorInfo.HasENamad" style="color:red"><i class="fa fa-times"></i></span><br/>
                            <a ng-href="{{BaseUrlPage.StoreVendorProductList}}/VendorID/{{vendorInfo.VendorID}}">مشاهده محصولات</a>
                        </div>
                    </info-window>
                    </ng-map>

                </div>
                </md-dialog-content>

                <!--<md-dialog-actions layout="row">
                
                <md-button ng-click="answer('not useful')">
                بستن
                </md-button>
                
                </md-dialog-actions>-->
            </form>
            </md-dialog>`,
            parent: angular.element(document.body),
            targetEvent: ev,
            locals: {
                item: item,
                BaseUrl: this.BaseUrlPage
            },
            clickOutsideToClose: true,
            fullscreen: true
        })

    }
    private goToProfile(tab) {
        let url = '/Orders-Tracking/UserId/3/' + tab
        window.open(url, '_blank');
    }
}






// WEBPACK FOOTER //
// ./src/components/product-icon-toolbar/product-icon-toolbar.controller.ts